import getFieldIdsByKey from './get-field-ids-by-key';
import generateFieldKey from './generate-field-key';
import setupSteps from '../constants/setup-steps';
import fieldNames from '../constants/field-names';
import fieldTypes from '../constants/field-types';
import { OTHER_FIELDS_ID } from '../constants/field-ids';

import { OTHER_VALUE } from '../constants/fields-values';

const EMPTY_VALUE = '—';

const extractSummaryItemData = ({ field, values }) => {
  const fieldValue = values[field.name];
  const summaryTitle = field.summaryTitle || field.title || '';
  let summaryValue;

  if (field.type === fieldTypes.CARD) {
    summaryValue = field.items.find((item) => item.id === fieldValue)?.title;
  }

  if (field.type === fieldTypes.INPUT || field.type === fieldTypes.TEXTAREA) {
    summaryValue = fieldValue.trim();
  }

  if (field.type === fieldTypes.CHECKBOX) {
    const labels = fieldValue.map((value) => {
      if (value === OTHER_VALUE) {
        return value;
      }
      const { summaryLabel, label } = field.options.find((option) => option.value === value) || {};

      return summaryLabel || label || '';
    });

    summaryValue = !!labels.length && labels.join(', ');
  }

  if (field.type === fieldTypes.RADIO) {
    if (fieldValue === OTHER_VALUE) {
      summaryValue = fieldValue;
    } else {
      const { summaryLabel, label } =
        field.options.find((option) => option.value === fieldValue) || {};

      summaryValue = summaryLabel || label || '';
    }
  }

  return {
    id: field.id,
    title: summaryTitle,
    value: summaryValue || EMPTY_VALUE,
  };
};

const collectSummeryFieldsData = ({ data, key, stepId, fields, values }) => {
  getFieldIdsByKey(key)
    .filter((id) => !OTHER_FIELDS_ID.includes(id))
    .forEach((fieldId) => {
      const field = fields.find(({ id }) => id === fieldId);
      const parentField = fields.find(({ id }) => id === field.parentId);

      if (parentField) {
        const value = values[parentField.name];
        if (parentField.subFields[value] !== field.id) return;
      }

      const itemData = extractSummaryItemData({ field, values });
      data.push({
        ...itemData,
        stepId,
      });
    });
};

const prepareSummaryData = (values, fields) => {
  let data = [];

  collectSummeryFieldsData({
    data,
    key: generateFieldKey(setupSteps.PROJECT),
    stepId: setupSteps.PROJECT,
    fields,
    values,
  });
  collectSummeryFieldsData({
    data,
    key: generateFieldKey(setupSteps.DETAILS, values[fieldNames.SERVICE]),
    stepId: setupSteps.DETAILS,
    fields,
    values,
  });
  collectSummeryFieldsData({
    data,
    key: generateFieldKey(setupSteps.CONTACT_INFO),
    stepId: setupSteps.CONTACT_INFO,
    fields,
    values,
  });

  OTHER_FIELDS_ID.forEach((fieldId) => {
    const field = fields.find(({ id }) => id === fieldId);
    const otherData = extractSummaryItemData({ field, values });

    data = data.map((item) => {
      if (item.id !== field.parentId) return item;
      if (!item.value.includes(OTHER_VALUE)) return item;

      let itemValue = item.value;

      if (itemValue === OTHER_VALUE) {
        itemValue = otherData.value;
      } else if (otherData.value === EMPTY_VALUE) {
        itemValue = item.value
          .split(', ')
          .filter((value) => value !== OTHER_VALUE)
          .join(', ');
      } else {
        itemValue = itemValue.replace(OTHER_VALUE, otherData.value);
      }

      return {
        ...item,
        value: itemValue,
      };
    });
  });

  return data;
};

export default prepareSummaryData;
